import { useLocation } from "react-router";


export function useUrlParam(paramName: string) {
  const location = useLocation();
  return decodeURI(String(new URLSearchParams(location.search).get(paramName) || ''))
}